<template>
    <v-container fluid pt-5>
        <v-toolbar flat scroll-off-screen app color="grey lighten-3">
            <v-layout wrap justify-center align-center>
                <v-flex xs2>
                    <img height="40" src="@/assets/img/logo.png"/>
                </v-flex>
                <v-flex xs8 text-xs-center>
                    <h2 class="font-weight-light">Confirmar Cita</h2>
                </v-flex>
                <v-flex xs2/>
            </v-layout>
        </v-toolbar>

        <v-layout wrap justify-center align-center>
            <v-flex xs12 md8 lg6 text-xs-center>
                <template v-if="status === 'loading'">
                    <h1 class="headline font-weight-light">Verificando</h1>
                    <small class="caption">Un momento por favor...</small>
                    <v-progress-linear height="2" :indeterminate="true"/>
                </template>

                <template v-if="status === 'failed'">
                    <h1 class="headline font-weight-light">Algo salió mal :(</h1>
                    <small class="caption">{{ failMessage }}</small>
                </template>

                <v-scale-transition>
                    <v-sheet color="transparent" v-show="status === 'success'" height="200">
                        <v-avatar size="60" color="success">
                            <v-icon color="white">fas fa-user-check</v-icon>
                        </v-avatar>
                        <h1 class="headline font-weight-light mt-2">{{ message }}</h1>
                        <h1 class="subtitle font-weight-light mt-2">Te esperamos!</h1>

                        <v-btn color="primary" depressed round @click="onPay" v-if="url">
                            Ir a pagar
                        </v-btn>
                    </v-sheet>
                </v-scale-transition>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import {ApiUtils} from '@/utils/ApiUtils'
import {mapState, mapMutations} from 'vuex'

export default {
    components: {},
    data() {
        return {
            status: 'success',
            message: '',
            failMessage: '',
            code: this.$route.params.code,
            url: null,
        }
    },
    computed: {
        ...mapState(['currentUser'])
    },
    mounted() {
        const vm = this
        vm.getCodeInfo()
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        onError(response) {
            const vm = this
            vm.failMessage = response.message || 'Ha ocurrido un error inesperado'
        },
        onSuccess() {
            const vm = this
            vm.status = 'success'
        },
        async getCodeInfo() {
            const vm = this
            const response = await ApiUtils.makePost('appointment/confirm', {code: vm.code})

            if (!response.ok) {
                vm.status = 'failed'
                const json = await response.json()
                vm.failMessage = json.message
                return
            }

            vm.status = 'success'
            const json = await response.json()
            vm.message = json.message
            vm.url = json.result.url || null
        },
        onPay() {
            const vm =this
            window.open(vm.url, '_blank')
        }
    }
}
</script>